var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_status_payment)?_c('vs-chip',{attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.message))]):_c('div',{staticStyle:{"text-align":"center","width":"100%"}},[_vm._v("...")])}
var staticRenderFns = []

export { render, staticRenderFns }